<template lang="pug">
  b-modal#linkedMatchLogInfo(
  ref="linkedMatchLogInfoModal"
  :title="$t('ui.linked_match_log')"
  centered
  no-fade
  ok-only
  no-enforce-focus
  size="xl"
  :busy="loading"
  @shown="shown")
    div(v-if="detail")
      div(v-if="filteredOldDetailList.length > 0")
        b-form-group(:label="$t('ui.old')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=100)
                      span {{ $t('ui.id') }}
                    th(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th
                      span {{ $tc("ui.leagues", 1) }}
                    th
                      span {{ $t("ui.home") }}
                    th
                      span {{ $t("ui.away") }}
                    th(width=60)
                      span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                    th(width=80)
                      span {{ $t("ui.short.match_date") }}
                    th(width=80)
                      span {{ $t("ui.short.match_time") }}
                    th(width=80)
                      span {{ $t("ui.sbo") }}
                    th(width=80)
                      span {{ $t("ui.ibc") }}
                    th(width=60)
                      span(:title="$t('ui.affect_value')") {{ $t("ui.short.affect_value") }}
                    th(width=60).text-center
                      span {{ $t("ui.ldiff") }}
                    th(width=60)
                      span {{ $t("ui.linked") }}
                    th(width=30).text-center
                      span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                    th(width=40).text-center
                      span(:title="$t('ui.swap_team')") {{ $t("ui.short.swap_team") }}
                    th(width=40).text-center
                      span(:title="$t('ui.manual_add')") {{ $t("ui.short.manual_add") }}
                    th(width=40).text-center
                      span(:title="$t('ui.manual_map')") {{ $t("ui.short.manual_map") }}
                    th(width=40).text-center
                      span(:title="$t('ui.manual_create')") {{ $t("ui.short.manual_create") }}
                    th(width=40).text-center
                      span(:title="$t('ui.remap')") {{ $t("ui.short.remap") }}
                tbody
                  tr(v-for="item in filteredOldDetailList")
                    td
                      span {{ item.match_id }}
                    td
                      span {{ item.sport_type }}
                    td
                      span(:title="item.league_name") {{ item.league_name }}
                    td
                      span(:title="item.home_name") {{ item.home_name }}
                    td
                      span(:title="item.away_name") {{ item.away_name }}
                    td.text-uppercase
                      span {{ item.market_type }}
                    td
                      span {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                    td
                      span {{ item.match_time }}
                    td
                      span {{ item.sbo_map }}
                    td
                      span {{ item.ibc_map }}
                    td
                      span {{ item.affect_value }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.ldiff, 'fas fa-times text-warning': !item.ldiff  }")
                    td
                      span {{ item.link_id }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.swap_team, 'fas fa-times text-warning': !item.swap_team  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.manual_add, 'fas fa-times text-warning': !item.manual_add  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.manual_map, 'fas fa-times text-warning': !item.manual_map  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.manual_create, 'fas fa-times text-warning': !item.manual_create  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.remap, 'fas fa-times text-warning': !item.remap  }")
      div(v-if="filteredNewDetailList.length > 0")
        b-form-group(:label="$t('ui.new')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=100)
                      span {{ $t('ui.id') }}
                    th(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th
                      span {{ $tc("ui.leagues", 1) }}
                    th
                      span {{ $t("ui.home") }}
                    th
                      span {{ $t("ui.away") }}
                    th(width=60)
                      span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                    th(width=80)
                      span {{ $t("ui.short.match_date") }}
                    th(width=80)
                      span {{ $t("ui.short.match_time") }}
                    th(width=80)
                      span {{ $t("ui.sbo") }}
                    th(width=80)
                      span {{ $t("ui.ibc") }}
                    th(width=60)
                      span(:title="$t('ui.affect_value')") {{ $t("ui.short.affect_value") }}
                    th(width=60).text-center
                      span {{ $t("ui.ldiff") }}
                    th(width=60)
                      span {{ $t("ui.linked") }}
                    th(width=30).text-center
                      span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                    th(width=40).text-center
                      span(:title="$t('ui.swap_team')") {{ $t("ui.short.swap_team") }}
                    th(width=40).text-center
                      span(:title="$t('ui.manual_add')") {{ $t("ui.short.manual_add") }}
                    th(width=40).text-center
                      span(:title="$t('ui.manual_map')") {{ $t("ui.short.manual_map") }}
                    th(width=40).text-center
                      span(:title="$t('ui.manual_create')") {{ $t("ui.short.manual_create") }}
                    th(width=40).text-center
                      span(:title="$t('ui.remap')") {{ $t("ui.short.remap") }}
                tbody
                  tr(v-for="item in filteredNewDetailList")
                    td
                      span {{ item.match_id }}
                    td
                      span {{ item.sport_type }}
                    td
                      span(:title="item.league_name") {{ item.league_name }}
                    td
                      span(:title="item.home_name") {{ item.home_name }}
                    td
                      span(:title="item.away_name") {{ item.away_name }}
                    td.text-uppercase
                      span {{ item.market_type }}
                    td
                      span {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                    td
                      span {{ item.match_time }}
                    td
                      span {{ item.sbo_map }}
                    td
                      span {{ item.ibc_map }}
                    td
                      span {{ item.affect_value }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.ldiff, 'fas fa-times text-warning': !item.ldiff  }")
                    td
                      span {{ item.link_id }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.swap_team, 'fas fa-times text-warning': !item.swap_team  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.manual_add, 'fas fa-times text-warning': !item.manual_add  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.manual_map, 'fas fa-times text-warning': !item.manual_map  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.manual_create, 'fas fa-times text-warning': !item.manual_create  }")
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.remap, 'fas fa-times text-warning': !item.remap  }")
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    detail: {
      type: Object
    },
    page: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      recordList: []
    };
  },
  computed: {
    filteredOldDetailList() {
      return this.recordList.filter((item) => {
        return item.type.toLowerCase() == 'old';
      });
    },
    filteredNewDetailList() {
      return this.recordList.filter((item) => {
        return item.type.toLowerCase() == 'new';
      });
    },
  },
  methods: {
    getRecord() {
      let url = config.auditLogDetailRecordUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.auditlog,
        log_id: this.detail.log_id,
        log_detail_id: this.detail.log_detail_id,
        audit_table_name: this.detail.audit_table_name
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.recordList = response.data.tbl_audit_log_detail_record;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    shown() {
      this.getRecord();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
